var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 4.16674H4.16659C3.61405 4.16674 3.08415 4.38623 2.69345 4.77693C2.30275 5.16763 2.08325 5.69754 2.08325 6.25007V20.8334C2.08325 21.3859 2.30275 21.9158 2.69345 22.3065C3.08415 22.6972 3.61405 22.9167 4.16659 22.9167H18.7499C19.3025 22.9167 19.8324 22.6972 20.2231 22.3065C20.6138 21.9158 20.8333 21.3859 20.8333 20.8334V13.5417M19.2708 2.60424C19.6852 2.18984 20.2472 1.95703 20.8333 1.95703C21.4193 1.95703 21.9814 2.18984 22.3958 2.60424C22.8102 3.01864 23.043 3.58069 23.043 4.16674C23.043 4.75279 22.8102 5.31484 22.3958 5.72924L12.4999 15.6251L8.33325 16.6667L9.37492 12.5001L19.2708 2.60424Z",
    stroke: "#6A6969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7f2852ebb126592bfe996c5f0b84cec5.svg";
export { ForwardRef as ReactComponent };